import parkAPI from "@/api/connect/park";
import { successMsg } from "@/api/lib";

/**
 * 园区详情
 *
 * @param
 *
 * @return responseData
 */
export const parkDetail = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .parkDetail(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 发送短信验证码
 *
 * @param phoneNumber 手机号
 *
 * @return responseData
 */
export const sendCode = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .sendCode(params)
      .then((responseData) => {
        successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 上传文件获取hos
 *
 * @param file formdata
 *
 * @return responseData
 */
export const uploadFile = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .uploadFile(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 验证短信验证码
 *
 * @param applyerPhone  申请人手机号（SM2加密）
 * @param code          验证码
 *
 * @return responseData
 */
export const validateCode = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .validateCode(params)
      .then((responseData) => {
        successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 新增园区接口
 *
 * @param parkApplyStr      身份认证
 * @param parkApplyStr.applyerName        姓名?
 * @param parkApplyStr.applyerPhone       手机号码
 * @param parkApplyStr.dataSource         身份认证?
 * @param parkApplyStr.idContrayImg       身份证正面?
 * @param parkApplyStr.idFrontImg         身份证反面?
 * @param parkApplyStr.workImg            工作证
 * @param industryParkStr   基本信息
 *
 * @return responseData
 */
export const addPark = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .addPark(params)
      .then((responseData) => {
        successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

export const addIndustryPark = addPark;

/**
 * 修改园区
 *
 * @param industryParkStr
 *
 * @return responseData
 */
export const updatePark = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .updatePark(params)
      .then((responseData) => {
        successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 修改园区
 *
 * @param parkId     园区id
 *
 * @return responseData
 */
export const undoPark = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .undoPark(params)
      .then((responseData) => {
        successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询我的园区列表信息
 *
 * @param phone     管理员手机号(sm2加密)
 *
 * @return responseData
 */
export const findByPhone = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .findByPhone(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询园区资源列表
 *
 * @param placeId     园区的iid
 *
 * @return responseData
 */
export const getYqzyList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqzyList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询园区动态列表
 *
 * @param placeId     园区的iid
 *
 * @return responseData
 */
export const getYqdtList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqdtList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询园区政策列表
 *
 * @param placeId     园区的iid
 *
 * @return responseData
 */
export const getYqzcList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqzcList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询园区活动列表
 *
 * @param placeId     园区的iid
 *
 * @return responseData
 */
export const getYqhdList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqhdList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询园区列表
 *
 * @param
 *
 * @return responseData
 */
export const getParkList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getParkList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 获取维度数据
 *
 * @param type 参数值：industryType（产业类型）、parkType（园区类型）、parkCarrier（园区载体）、parkLabel（园区标签）
 *
 * @return responseData
 */
export const getDimensionList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getDimensionList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

export const findOption = getDimensionList;

/**
 * 获取区划数据
 *
 * @param
 *
 * @return responseData
 */
export const getDistrictList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getDistrictList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 获取区划数据
 *
 * @param
 *
 * @return responseData
 */
export const getCodeList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getCodeList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 园区企业所属行业分布
 *
 * @param placeId
 *
 * @return responseData
 */
export const getParkIndustryList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getParkIndustryList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 园区企业注册资本分布
 *
 * @param placeId
 *
 * @return responseData
 */
export const getParkCapitalList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getParkCapitalList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 园区企业
 *
 * @param placeId
 *
 * @return responseData
 */
export const getParkComList = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getParkComList(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};
/**
 * 园区建议反馈提交
 *
 * @param  params

 *
 * @return responseData
 */
export const getUserBack = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getUserBack(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};
/**
 * 第三方接口查询企业信息
 *
 * @param  params

 *
 * @return responseData
 */
export const getEnterprise = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getEnterprise(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};
/**
 * 第三方接口查询企业信息
 *
 * @param  params

 *
 * @return responseData
 */
export const getCodeId = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getCodeId(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 园区动态详情
 *
 * @param dynamicInfoId
 *
 * @return responseData
 */
export const getYqdtDetail = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqdtDetail(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 园区政策详情
 *
 * @param policyId
 *
 * @return responseData
 */
export const getYqzcDetail = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqzcDetail(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 园区活动详情
 *
 * @param activityId
 *
 * @return responseData
 */
export const getYqhdDetail = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getYqhdDetail(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};
/**
 * 根据园区产业类型分组统计
 *
 * @param
 *
 * @return responseData
 */
export const getIndustryType = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .getIndustryType(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};

/**
 * 查询是否是该园区管理员
 *
 * @param
 *
 * @return responseData
 */
export const checkIsManager = (params) => {
  return new Promise((resolve, reject) => {
    parkAPI
      .checkIsManager(params)
      .then((responseData) => {
        // successMsg(responseData);
        resolve(responseData);
      })
      .catch((error) => reject(error));
  });
};
